import React, { useEffect, useState, useRef } from 'react';
import { fetchLogo } from '../services/apiService';

const MIN_SPLASH_MS = 2000;

function getNormalizedHost() {
  return window.location.hostname.replace(/^www\./, '');
}

function Splash({ onSplashComplete }) {
  const [loaderLogo, setLoaderLogo] = useState(null);
  const [noSplash, setNoSplash] = useState(false);
  const [visible, setVisible] = useState(true);
  const mountTime = useRef(performance.now());

  // Fetch loader_logo using centralized API (deduplicates across components)
  useEffect(() => {
    const origin = getNormalizedHost();
    if (!origin) { setNoSplash(true); return; }

    let cancelled = false;

    fetchLogo(origin)
      .then((data) => {
        if (cancelled) return;
        const item = Array.isArray(data) ? data[0] : data;
        const path = item?.loader_logo;
        if (path) {
          setLoaderLogo(
            path.startsWith('http') ? path : `${process.env.REACT_APP_API_URL}/storage/${path}`
          );
        } else {
          setNoSplash(true);
        }
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('Error fetching loader_logo:', err);
        setNoSplash(true);
      });

    return () => { cancelled = true; };
  }, []);

  // Once we know what to show, enforce minimum 2s then fade out
  useEffect(() => {
    if (!loaderLogo && !noSplash) return; // still waiting for API

    const elapsed = performance.now() - mountTime.current;
    const remaining = Math.max(0, MIN_SPLASH_MS - elapsed);

    const displayTimer = setTimeout(() => {
      const splashElement = document.querySelector('.splash-screen');
      if (splashElement) {
        splashElement.classList.add('fade-out');
      }

      const fadeTimer = setTimeout(() => {
        setVisible(false);
        if (onSplashComplete) {
          onSplashComplete();
        }
      }, 500);

      return () => clearTimeout(fadeTimer);
    }, remaining);

    return () => clearTimeout(displayTimer);
  }, [loaderLogo, noSplash, onSplashComplete]);

  if (!visible) return null;

  // Show nothing until API responds — then show splash or dots
  if (!loaderLogo && !noSplash) {
    return <div className="splash-screen" />;
  }

  return (
    <div className="splash-screen">
      {loaderLogo ? (
        <img src={loaderLogo} alt="Loading..." />
      ) : (
        <div className="three-dots-loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </div>
  );
}

export default Splash;
